import { render, staticRenderFns } from "./TimelineBrandView.vue?vue&type=template&id=64a55108&scoped=true"
import script from "./TimelineBrandView.vue?vue&type=script&lang=js"
export * from "./TimelineBrandView.vue?vue&type=script&lang=js"
import style0 from "./TimelineBrandView.vue?vue&type=style&index=0&id=64a55108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a55108",
  null
  
)

export default component.exports